module.exports = __webpack_public_path__ + "static/media/logo.c6775e21.svg";